module.exports = __webpack_public_path__ + "img/checkmark.82b777b1.svg";